import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import DataProviderContext from '../react/DataProviderContext';
import ReviewsQuery from '../queries/user-generated-content/reviews.graphql';
import { useQuery } from './useQuery';

const defaultVariables = {
  filters: {
    isVerifiedPurchase: false,
    prosCons: null,
    starRatings: null,
  },
  searchTerm: null,
  sortBy: 'photoreview',
  startIndex: 1
};

const useReviews = ({
  itemId, options, variables = defaultVariables, skip = false, ssr = true, lazy = false
}) => {
  let opts = options;
  const context = useContext(DataProviderContext);
  if (typeof opts === 'undefined') {
    opts = {
      skip,
      ssr,
      fetchPolicy: context.fetchPolicy || 'cache-first',
      errorPolicy: 'all',
      variables: {
        itemId,
        ...variables
      }
    };
  }
  if (lazy) {
    return useLazyQuery(ReviewsQuery, opts);
  }

  return useQuery(ReviewsQuery, opts);
};

export default useReviews;
